export const initialState = {
  inProgress: false,
  name: null,
  component: null,
  loading: null,
  error: null,
  success: null,
  nextAction: null,
  onContinue: null,
  continueLabel: 'Continue',
  // ATAD-146: the label of the onContinue currently wired up, when its body
  // named one (SET_ON_CONTINUE's continueLabel). Wins over continueLabel.
  continueLabelOverride: null,
  continueButtonModifier: 'primary',
  noContinue: false,
  onSubmit: null,
  isReactHookForm: false,
  // ATAD-146: 'panes' is the Upload File modal's fixed-size, two-pane shell
  // (no body padding, so its sources rail runs edge to edge). null = default.
  layout: null,
  // ATAD-146: a secondary Cancel button left of Continue.
  showCancel: false,
};

export const START_ACTION = 'start-action';
export const SET_ON_CONTINUE = 'set-on-continue';
export const SET_LOADING = 'set-loading';
export const CANCEL_ACTION = 'cancel-action';
export const SET_ON_CANCEL = 'set-on-cancel';
export const SET_SUCCESS = 'set-success';
export const CLEAR_SUCCESS = 'clear-success';
export const CLEAR_NEXT_ACTION = 'clear-next-action';
export const RESET = 'reset';
export const SET_ON_SUBMIT = 'set-on-submit';

export const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case START_ACTION:
      return {
        ...initialState,
        success: state.success,
        inProgress: true,
        name: payload.name,
        component: payload.component,
        continueLabel: payload.continueLabel || initialState.continueLabel,
        continueButtonModifier:
          payload.continueButtonModifier || initialState.continueButtonModifier,
        noContinue: payload.noContinue
          ? payload.noContinue
          : initialState.noContinue,
        isReactHookForm: payload.isReactHookForm,
        layout: payload.layout ?? initialState.layout,
        showCancel: !!payload.showCancel,
      };
    case SET_ON_CANCEL:
      return {
        ...state,
        onCancel: payload.onCancel,
      };
    case SET_ON_CONTINUE:
      return {
        ...state,
        onContinue: payload.onContinue,
        // ATAD-146: a body can name the button it wires up (the Upload File
        // modal's Model tab says "Import"). The label belongs to that
        // onContinue, so a SET_ON_CONTINUE without one — any other body, or
        // switching the file type — shows the modal's own label again.
        continueLabelOverride: payload.continueLabel ?? null,
      };
    case SET_SUCCESS:
      return {
        ...initialState,
        success: payload.message,
        nextAction: payload.nextAction || undefined,
      };
    case CLEAR_SUCCESS:
      return {
        ...state,
        success: null,
      };
    case CLEAR_NEXT_ACTION:
      return {
        ...state,
        nextAction: null,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: payload.loading,
      };
    case CANCEL_ACTION:
      return {
        ...initialState,
        inProgress: false,
      };
    case RESET:
      return {
        ...initialState,
      };
    case SET_ON_SUBMIT:
      return {
        ...state,
        onSubmit: payload.onSubmit,
      };
    default:
      return state;
  }
};
